// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3JyDN","selects":"Documents_selects__16_7_"};